import * as React from 'react';
import { EImageSizeType } from '../../types/index';
import { PictogramPlaceholderImages40 } from '@cian/ui-kit-design-tokens/pictograms';
import { IconPlaceholderImages24 } from '@cian/ui-kit-design-tokens/icons';
import { jsx as _jsx } from "react/jsx-runtime";
export var Error = function Error(_ref) {
  var className = _ref.className,
    size = _ref.size;
  return /*#__PURE__*/_jsx("div", {
    className: className,
    children: size === EImageSizeType.L ? /*#__PURE__*/_jsx(PictogramPlaceholderImages40, {}) : /*#__PURE__*/_jsx(IconPlaceholderImages24, {})
  });
};